import { render, staticRenderFns } from "./AdminCreate.vue?vue&type=template&id=6fa50075"
import script from "../../controllers/admin/admin-create.js?vue&type=script&lang=js&external"
export * from "../../controllers/admin/admin-create.js?vue&type=script&lang=js&external"
import style0 from "./AdminCreate.vue?vue&type=style&index=0&id=6fa50075&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports